import {
  Box,
  Button,
  Flex,
  HStack,
  Image,
  Menu,
  MenuButton,
  MenuList,
  useMenuContext,
} from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';
import {
  InDesktop,
  InMobile,
  useWalletConnectModalStore,
} from '@cronos-app/components';
import { currentWallet } from '@cronos-app/wallet';
import { Address } from '@ui/components/Address';
import { MaskIcon } from '@ui/components/MaskIcon';
import { useIsWrongNetwork } from '@ui/hooks/useIsWrongNetwork';
import { useSwitchNetwork } from '@ui/hooks/useSwitchNetwork';
import { useTranslations } from 'next-intl';

export const WalletNavItem = () => {
  const t = useTranslations();
  const account = currentWallet.useAccount();
  const isConnected = currentWallet.useIsConnected();
  const chainId = currentWallet.useChainId();
  const switchNetworkMutation = useSwitchNetwork();
  const walletConfig = currentWallet.useWalletConfig();
  const desiredNetwork = currentWallet.useDesiredNetwork();
  const openWalletModal = useWalletConnectModalStore((s) => s.openModal);
  const isWrongNetwork = useIsWrongNetwork();
  const desiredChainId =
    isWrongNetwork || chainId === undefined ? desiredNetwork : chainId;

  if (isConnected && isWrongNetwork) {
    return (
      <Button
        variant="ghost"
        size="sm"
        role="button"
        color="red.600"
        onClick={() => {
          switchNetworkMutation.mutate(desiredNetwork);
        }}
      >
        {t('card.wrong network')}
      </Button>
    );
  }

  if (isConnected) {
    return (
      <Menu>
        <MenuButton>
          <HStack gap="8px">
            <Flex flexDir="column" alignItems="flex-end">
              <HStack gap="8px">
                <Image
                  src={walletConfig.icon}
                  boxSize="16px"
                  alt="wallet icon"
                />
                <Address address={account ?? ''} textStyle="body1Bold" />
              </HStack>
            </Flex>
            <MenuArrowIcon />
          </HStack>
        </MenuButton>
        <MenuList p="0">
          <Box
            p="16px"
            borderTopWidth="1px"
            borderColor="brand.gray-scale-border-10"
          >
            <Button
              variant="link"
              size="sm"
              onClick={() => {
                currentWallet.disconnect();
              }}
            >
              {t('card.disconnect')}
            </Button>
          </Box>
        </MenuList>
      </Menu>
    );
  }

  return (
    <Button
      variant="ghost"
      color="white"
      bgColor="#159DFF"
      size="sm"
      rounded="4px"
      textTransform="capitalize"
      onClick={() => {
        openWalletModal(desiredChainId);
      }}
    >
      <InDesktop>{t('card.connect wallet')}</InDesktop>
      <InMobile>{t('card.connect')}</InMobile>
    </Button>
  );
};

const MenuArrowIcon = () => {
  const { isOpen } = useMenuContext();
  return (
    <MaskIcon
      icon={`url(${getAssetUrl('/masks/down-arrow.svg')})`}
      boxSize="24px"
      bg="brand.white"
      transform={isOpen ? 'rotate(180deg)' : undefined}
    />
  );
};
